import React from "react";
import { Message, Grid } from "semantic-ui-react";
import WeightDisplay from "./WeightDisplay";

const MessageDisplay = (props) => {
  const { currentBox, resetWeightCallback, imageFound, branchID } = props;

  const _getInstruction = (validationResult) => {
    switch (validationResult) {
      case 1:
      case -1:
        return "Kör paketet genom vågen igen.";
      case 11:
      case 10:
      case 2:
        return "Kontrollera paketets innehåll";
      case 0:
      default:
        return "";
    }
  };
  function _getValidationType(validationResult, boxValidations) {
    if (validationResult == -1 || validationResult == 1) {
      if (boxValidations.length > 0) {
        return "(kunde inte skanna fraktetikett)";
      } else {
        return "(kunde inte skanna lådetikett)";
      }
    } else {
      return "";
    }
  }
  const validationResult =
    currentBox.iPackBox && !currentBox.previouslyControlled
      ? currentBox.iPackBox.validationResult
      : -2;
  const validationResultString = currentBox.iPackBox
    ? !currentBox.previouslyControlled
      ? currentBox.validationResultString
      : "Kontrollerad maskinorder"
    : "Manuell order";
  const iPackShipping = currentBox.iPackBox
    ? currentBox.shippings.find((s) => s.iPackBoxID > -1)
    : undefined;

  return branchID !== 15 || (branchID === 15 && validationResult === 3) ? (
    <Message
      size="large"
      color={
        [0, -2].includes(validationResult) || currentBox.previouslyControlled ? "success" : "red"
      }
      className="validation-result"
    >
      <Grid columns={2}>
        <Grid.Row>
          <Grid.Column>
            <b>{validationResultString?.toUpperCase()}</b>
          </Grid.Column>
          <Grid.Column>{_getInstruction(validationResult)}</Grid.Column>
          <Grid.Column>{""}</Grid.Column>
          <Grid.Column>
            {_getValidationType(validationResult, currentBox.boxValidations)}
          </Grid.Column>
        </Grid.Row>
        {validationResult === 0 || (validationResult > 1 && branchID !== 15) ? (
          <Grid.Row>
            <Grid.Column width={16}>
              <WeightDisplay
                validationResult={validationResult}
                shippingWeight={iPackShipping.weight}
                iPackMeasuredWeight={iPackShipping.iPackMeasuredWeight}
                resetWeightCallback={resetWeightCallback}
                currentBox={currentBox}
                imageFound={imageFound}
              />
            </Grid.Column>
          </Grid.Row>
        ) : (
          ""
        )}
      </Grid>
    </Message>
  ) : null;
};
export default MessageDisplay;
